<template>
    <div class="kefu" >
        <div v-if="$parent.company.config.openOnline === 1" :class="{out:showClass}">
            <div class="pack-up cp color-blue" @click="closeOpen" v-if="!showClass">
                <span class="iconfont icon-ziyuan"></span>
                收起
            </div>
            <div class="pack-down cp color-blue" @click="closeOpen" v-if="showClass">
                <span class="iconfont icon-ziyuan dib"></span>展开
            </div>
            <ul v-if="!showClass">
                <li v-if="$parent.company.config.onlineInfo.onlineTel != ''">
                    <span class="zhu ac">
                        <i class="icons kf-phone"></i>
                        电话
                    </span>
                    <div class="fu">电话：{{$parent.company.config.onlineInfo.onlineTel}}</div>
                </li>
                <li v-if="$parent.company.config.onlineInfo.onlineQq != ''">
                    <span class="zhu ac">
                        <i class="icons kf-qq"></i>
                        QQ
                    </span>
                    <div class="fu">QQ：{{$parent.company.config.onlineInfo.onlineQq}}</div>
                </li>
                <li v-if="$parent.company.config.onlineInfo.onlineWx != ''">
                    <span class="zhu ac">
                        <i class="icons kf-wx"></i>
                        微信
                    </span>
                    <div class="fu wx">
                        <img class="img" :src="$parent.company.config.onlineInfo.onlineWx" alt="">
                        <span class="db mt10">{{$parent.company.config.onlineInfo.nickName}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="newBan" @click="goOld" v-if="!showClass">
            <img class="" src="../../static/images/qiehaun.png" alt="">
            <div>新版</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "kefu",
    props: {},
    data() {
        return {
            showClass:false
        }
    },
    mounted() {
       let customService = sessionStorage.getItem('customService');
       if(customService){
           this.showClass = JSON.parse(customService);
       }
    },
    created() {

    },
    methods: {
        closeOpen (){
            this.showClass = !this.showClass;
            sessionStorage.setItem('customService',JSON.stringify(this.showClass));
        },
        //切换新版
        goOld(){
            setTimeout(()=>{
                window.location.href = window.location.protocol+'//'+ window.location.host + '/nindex';
            },500)
        },
	}
}
</script>
<style scoped>
    .newBan{
        width: 52px;
        height: 60px;
        text-align: center;
        background: #fff;
        cursor:pointer;
        margin-top: 50px;
        border: 1px solid #eee;
    }
    .newBan img{width: 25px;margin-top: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/kefu.vue